import { useState, useEffect, useContext } from 'react';
import api from './api/axiosInstance';
import { UserContext } from './UserContext';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Sidebar from './Sidebar.js';
import { Form, Row, Col, Card, Table, Button, Image} from 'react-bootstrap';
// import DonationFilter from './DonationFilter';
import Pagination from 'react-bootstrap/Pagination';
import Breadcrumb from './Breadcrumb';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import icNoDonations from './assets/img/ic-empty-box.svg';
import DonateModal from './DonateModal';
import icSucess from './assets/img/ic-celebration-circle.svg';
import icEye from './assets/img/ic-eye.svg';
import icEyeClosed from './assets/img/ic-eye-closed.svg';

const DonationsMy = () => {
    const [donations, setDonations] = useState([]);
    const [filteredDonations, setFilteredDonations] = useState([]);
    const [downloadingId, setDownloadingId] = useState(null);
    
    const [donationsPerPage, setDonationsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastDonation = currentPage * donationsPerPage;
    const indexOfFirstDonation = indexOfLastDonation - donationsPerPage;
    const currentDonations = filteredDonations.slice(indexOfFirstDonation, indexOfLastDonation);

    const { user } = useContext(UserContext);
    
    const [sortOrderDate, setSortOrderDate] = useState('asc');
    const [sortOrderAmount, setSortOrderAmount] = useState('asc');
    
    const [tickets, setTickets] = useState([]);

    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showCanceledModal, setShowCanceledModal] = useState(false);
    const [showDonateModal, setShowDonateModal] = useState(false);


    const [donateAmount, setDonateAmount] = useState(100);
    const [donateLoading, setDonateLoading] = useState(false);
    const [donateError, setDonateError] = useState('');

    const [successSessionId, setSuccessSessionId] = useState('');
    const [magicLoading, setMagicLoading] = useState(false);
    const [magicSent, setMagicSent] = useState(false);

    const isDonatorUser = user?.role === 'donatorUser';

    const [showSetPwdModal, setShowSetPwdModal] = useState(false);
    const [pwd1, setPwd1] = useState('');
    const [pwd2, setPwd2] = useState('');
    const [pwdLoading, setPwdLoading] = useState(false);
    const [pwdMsg, setPwdMsg] = useState('');

    const [showPwd1, setShowPwd1] = useState(false);
    const [showPwd2, setShowPwd2] = useState(false);

    const [showPwdSuccessModal, setShowPwdSuccessModal] = useState(false);

    const validatePassword = (p1, p2) => { // ✅
        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;

        if (!passwordRegex.test(p1)) {
            setPwdMsg('Password must be at least 8 characters and include 1 uppercase, 1 lowercase, 1 number, and 1 special character.');
            return false;
        }
        if (p1 !== p2) {
            setPwdMsg('Passwords do not match.');
            return false;
        }
        setPwdMsg('');
        return true;
    };

    // ✅ live password requirement checks (updates as user types)
    const pwdChecks = {
        minLen: (pwd1 || '').length >= 8,
        lower: /[a-z]/.test(pwd1 || ''),
        upper: /[A-Z]/.test(pwd1 || ''),
        number: /\d/.test(pwd1 || ''),
        special: /[^A-Za-z0-9]/.test(pwd1 || ''),
    };

    // ✅ optional: confirm match check (only show when user starts typing pwd2)
    const pwdMatch = (pwd2 || '').length ? pwd1 === pwd2 : null;


    const submitPassword = async () => {
        setPwdMsg('');

        // ✅ strong password validation
        if (!validatePassword(pwd1, pwd2)) return; // ✅

        try {
            setPwdLoading(true);
            await api.post('/api/auth/donator/set-password', { password: pwd1 });

            // ✅ close pwd modal + open success modal
            setShowSetPwdModal(false);
            setShowPwdSuccessModal(true);

            // ✅ optional: cleanup
            setPwd1('');
            setPwd2('');
            setPwdMsg('');
            setShowPwd1(false); // ✅
            setShowPwd2(false); // ✅
        } catch (err) {
            setPwdMsg(err.response?.data?.msg || 'Failed to set password.');
        } finally {
            setPwdLoading(false);
        }
    };

    const formatMoneyFromCents = (amountCents, currency = '€') => {
        if (!Number.isFinite(amountCents)) return '—';

        const major = Math.round(amountCents / 100);

        return new Intl.NumberFormat('en-US', {
            maximumFractionDigits: 0,
        }).format(major) + ` ${currency.toUpperCase()}`;
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        const isSuccess = params.get('success') === '1';
        const isCanceled = params.get('canceled') === '1';

        if (isSuccess) setShowSuccessModal(true);
        if (isCanceled) setShowCanceledModal(true);

        // ✅ optional: clean URL so modal won't re-open on refresh
        if (isSuccess || isCanceled) {
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    const getDonationDateMs = (d) => {
        // tries common shapes: donation.createdAt, createdAt, donation.date, date
        const raw =
            d?.donation?.createdAt ??
            d?.createdAt ??
            d?.donation?.date ??
            d?.date ??
            null;

        const ms = raw ? new Date(raw).getTime() : 0;
        return Number.isFinite(ms) ? ms : 0;
    };

    const formatDonationDate = (d) => {
        const ms = getDonationDateMs(d);
        if (!ms) return '—';
        return new Date(ms).toLocaleDateString(); // ✅ you can switch to toLocaleString() if you want time too
    };

    const getDonationAmountNum = (d) => {
        const cents = d?.donation?.amount ?? d?.amount ?? 0;
        return Number.isFinite(cents) ? cents : 0;
    };

    const formatDonationAmount = (d) => {
        const cents = d?.donation?.amount ?? d?.amount;
        const currency = d?.donation?.currency ?? 'chf';

        return formatMoneyFromCents(cents, currency);
    };


    // Sorting utilities
    const toggleOrder = (curr) => (curr === 'asc' ? 'desc' : 'asc');

    const sortDonationsByDate = () => {
        const next = toggleOrder(sortOrderDate) || 'asc';
        setSortOrderDate(next);
        setFilteredDonations((prev) => {
            const arr = [...prev];
            arr.sort((a, b) => {
                const aMs = getDonationDateMs(a);
                const bMs = getDonationDateMs(b);
                return next === 'asc' ? aMs - bMs : bMs - aMs;
            });
            return arr;
        });
    };

    const sortDonationsByAmount = () => {
        const next = toggleOrder(sortOrderAmount) || 'asc';
        setSortOrderAmount(next);
        setFilteredDonations((prev) => {
            const arr = [...prev];
            arr.sort((a, b) => {
                const aAmt = getDonationAmountNum(a);
                const bAmt = getDonationAmountNum(b);
                return next === 'asc' ? aAmt - bAmt : bAmt - aAmt;
            });
            return arr;
        });
    };

    useEffect(() => {
        if (!user) return;

        const role = user?.role;
        const canSeeTickets = role === 'titanAdmin' || role === 'superadmin';

        if (!canSeeTickets) return; // ✅ tickets ONLY for titanAdmin/superadmin

        const fetchTickets = async () => {
            try {
                const res = await api.get(`/api/tickets`);
                setTickets(Array.isArray(res.data) ? res.data : []);
            } catch (error) {
                console.error('Error fetching tickets:', error);
            }
        };

        fetchTickets();
    }, [user]);

    useEffect(() => {
        if (user) fetchDonations();
    }, [user]);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        const success = params.get('success') === '1';
        const canceled = params.get('canceled') === '1';
        const sid = params.get('session_id');

        if (success) {
            if (sid) setSuccessSessionId(sid); // ✅ keep for magic link
            setShowSuccessModal(true);

            // ✅ clean URL so refresh doesn't re-open
            navigate('/donations-my', { replace: true });
        }

        if (canceled) {
            setShowCanceledModal(true);
            navigate('/donations-my', { replace: true });
        }
    }, [location.search, navigate]);

    // 🟢 NEW: auto-open donate modal when coming from WP (?donate=1)
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const donate = params.get('donate');
        const amount = params.get('amount');

        if (donate === '1') {
            // ✅ optional amount prefill
            if (amount !== null && amount !== '') {
                const n = Number(amount);
                if (Number.isFinite(n) && n > 0) setDonateAmount(Math.round(n));
            }

            setShowDonateModal(true);

            // ✅ clean URL so it won't reopen on refresh
            params.delete('donate');
            params.delete('amount');
            const nextQs = params.toString();
            navigate(`${location.pathname}${nextQs ? `?${nextQs}` : ''}`, { replace: true });
        }
    }, [location.search]); // ✅ keep it reactive to query changes

    const fetchDonations = async () => {
        try {
            const res = await api.get(`/api/payments/donations/my`);
            setDonations(res.data);
            setFilteredDonations(res.data); // Initialize with full list
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    };

    const totalPages = Math.ceil(filteredDonations.length / donationsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const noDonations = filteredDonations.length === 0;

    // ✅ Download donation certificate PDF (Blob -> file download)
    const downloadCertificate = async (donationItem) => {
        const donationId = donationItem?._id;
        if (!donationId) return;

        try {
            setDownloadingId(donationId); // ✅
            const res = await api.get(`/api/payments/donations/${donationId}/certificate`, {
                responseType: 'blob', // ✅ IMPORTANT
            });

            const blob = new Blob([res.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `donation-certificate-${donationId}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Certificate download failed:', err);
        } finally {
            setDownloadingId(null); // ✅
        }
    };

    // ✅ For success modal: download "latest" donation by date
    const downloadLatestCertificate = () => {
        // ✅ Case 1: donation exists (normal donator flow)
        if (filteredDonations?.length) {
            return downloadCertificate(filteredDonations[0]);
        }

        // ✅ Case 2: logged-in user but no filtered donations
        if (user) {
            // fallback: backend decides what "latest" means
            return downloadCertificate(); // ✅ no args
        }
    };

    const handleDonatePay = async (payloadOrIsPublic) => {
        setDonateError('');

        // ✅ support both: onPay(isPublic) and onPay({ isPublic, donor })
        const payload =
            typeof payloadOrIsPublic === 'object' && payloadOrIsPublic !== null
                ? payloadOrIsPublic
                : { isPublic: !!payloadOrIsPublic };

        const isPublic = !!payload.isPublic;
        const donor = payload.donor || null; // ✅ { firstName, familyName, email }

        if (!Number.isInteger(donateAmount) || donateAmount <= 0) {
            setDonateError('Please enter a whole amount (1, 2, 5, …)');
            return;
        }

        // ✅ If donating as guest, require donor fields (basic guard)
        if (donor) {
            const firstName = String(donor.firstName || '').trim();
            const familyName = String(donor.familyName || '').trim();
            const email = String(donor.email || '').trim();

            if (!firstName || !familyName || !email) {
                setDonateError('Please enter First name, Family name and Email.');
                return;
            }
        }

        setDonateLoading(true);

        try {
            const res = await api.post('/api/payments/create-checkout-session', {
                amount: donateAmount,
                isPublic,
                donor, // ✅ backend will use this to create/find donatorUser
            });

            if (res.data?.url) {
                window.location.href = res.data.url;
            } else {
                setDonateError('No checkout URL returned from server.');
            }
        } catch (err) {
            console.error('Payment error:', err);
            setDonateError(err.response?.data?.message || err.message || 'Failed to start payment.');
        } finally {
            setDonateLoading(false);
        }
    };

    const sendMagicLink = async () => {
        if (!successSessionId) return;

        try {
            setMagicLoading(true);
            await api.post('/api/payments/magic-link-by-session', {
                sessionId: successSessionId,
            });
            setMagicSent(true);
        } catch (err) {
            console.error('Magic link error:', err);
        } finally {
            setMagicLoading(false);
        }
    };

    const hasDonatorPassword =
        !!(user?.passwordSet ?? user?.hasPassword ?? user?.hasPasswordSet); // ✅

    return (
        <>
            {user ? <Sidebar ticketCount={tickets.length} /> : null}
            <main className={`main-content flex-grow-1 ${!user ? 'ms-0 pt-0' : ''}`}>
                <Container>
                    <Row>
                        <Col>
                            <Breadcrumb />
                        </Col>
                    </Row>
                    <div className="mb-4">
                        <Card className="card-premium">
                            <Card.Body className="pt-0">

                                <div className="mb-1">
                                    <Card className="card-premium">
                                        <Card.Body>
                                            <h1 className="mb-4">Donations</h1>
                                            <Row>
                                                <Col className="col-12 col-lg-6 mb-4 mb-lg-0">
                                                    <h2 className="font-size-md mb-2">Why Donate?</h2>
                                                    <p className="font-size-md mb-4">
                                                        Your support helps us expand to more cities worldwide and make the platform smarter and faster—so the next generation of students can access better tools, services, and global opportunities with confidence. As a company, you also receive an ESG certificate that can be credited to your sustainability scoring and rating.
                                                    </p>
                                                    <Button variant="primary" onClick={() => setShowDonateModal(true)}>Make a Donation</Button>

                                                    {isDonatorUser && (
                                                        <Button
                                                            variant="outline-secondary"
                                                            className="ms-lg-2"
                                                            onClick={() => {
                                                                setShowSuccessModal(false); // ✅ close success modal if open
                                                                setShowSetPwdModal(true);
                                                            }}
                                                        >
                                                            {hasDonatorPassword ? 'Change password' : 'Set password'} {/* ✅ */}
                                                        </Button>
                                                    )}
                                                </Col>

                                                <Col className="col-12 col-lg-6">
                                                    <h2 className="font-size-md mb-2">About the certificate</h2>
                                                    <p className="font-size-md">
                                                        In 2015, world leaders set 17 Global Goals for Sustainable Development. Our platform supports 4 goals and 8 targets. Every donation comes with a contribution certificate, and all funds are fully dedicated to improving our young talent platform.
                                                    </p>
                                                    {/* <Link to="" className="font-size-md"><strong>See the certificate</strong></Link> */}
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </div>
                                    <Row>
                                        <Col lg={6}>
                                            <h2 className="py-5 mb-1">List of previous donations</h2>
                                        </Col>
                                    </Row>
                        
                                    <Row>
                                        <Col xs={12}>
                                            {/* <DonationFilter
                                                searchQuery={searchQuery}
                                                setSearchQuery={setSearchQuery}
                                                donations={donations}
                                            /> */}
                                        </Col>
                                    </Row>
                                    {noDonations ? (
                                        <Row>
                                            <Col md={12}>
                                                <Row className="mb-3">
                                                    <Col md={6} className="no-result offset-md-3 d-flex flex-column justify-content-center align-items-center text-center">
                                                        <Image src={icNoDonations} alt="No Donations" className="mb-4" />
                                                        <h2 className="mb-3">No Donations yet.</h2>
                                                        <p className="mb-4">Your Donations will be displayed here.</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row>
                                            <Col>
                                                <div className="table-responsive list">
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <th className="th-fixed-city-id" onClick={() => sortDonationsByDate()} style={{ cursor: 'pointer' }}>
                                                                    <div>
                                                                        Date
                                                                        <span>
                                                                            <FaCaretUp   className={sortOrderDate === 'asc'  ? 'text-primary' : ''} />
                                                                            <FaCaretDown className={sortOrderDate === 'desc' ? 'text-primary' : ''} />
                                                                        </span>
                                                                    </div>
                                                                </th>

                                                                <th className="th-fixed-city-name">
                                                                </th>

                                                                <th className="th-fixed-city-status" onClick={() => sortDonationsByAmount()} style={{ cursor: 'pointer' }}>
                                                                    <div>
                                                                        Amount
                                                                        <span>
                                                                            <FaCaretUp   className={sortOrderAmount === 'asc'  ? 'text-primary' : ''} />
                                                                            <FaCaretDown className={sortOrderAmount === 'desc' ? 'text-primary' : ''} />
                                                                        </span>
                                                                    </div>
                                                                </th>

                                                                <th></th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {currentDonations.map((donation) => {
                                                                const nameVal = donation?.donation?.name ?? '';
                                                                return (
                                                                    <tr key={donation._id} style={{ cursor: 'pointer' }}>
                                                                        <td>{formatDonationDate(donation)}</td>
                                                                        <td></td>
                                                                        <td>{formatDonationAmount(donation)}</td>
                                                                        <td className="text-end">
                                                                            <Button
                                                                                variant="outline-secondary"
                                                                                size="sm"
                                                                                onClick={() => downloadCertificate(donation)}
                                                                                disabled={downloadingId === donation._id} // ✅
                                                                            >
                                                                                {downloadingId === donation._id ? 'Downloading…' : 'View Certificate'}
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                
                                    {/* Pagination Row with Total Count, Items Per Page Selector & "Go to Page" Input */}
                                    <Row className="pagination-wrapper">
                                        <Col className="d-flex align-items-center mb-4 mb-lg-0">
                                            <span>Total&nbsp;{filteredDonations.length} Donations</span>
                                            <Pagination>
                                                <Pagination.Prev 
                                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
                                                    disabled={currentPage === 1}
                                                />
                                                {[...Array(totalPages).keys()].map(number => (
                                                    <Pagination.Item 
                                                        key={number + 1} 
                                                        active={number + 1 === currentPage} 
                                                        onClick={() => handlePageChange(number + 1)}
                                                    >
                                                        {number + 1}
                                                    </Pagination.Item>
                                                ))}
                                                <Pagination.Next 
                                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
                                                    disabled={currentPage === totalPages}
                                                />
                                            </Pagination>
                                        </Col>

                                        <Col className="pagination-controls">
                                            <div className="pagination-controls-per-page">
                                                <Form.Select
                                                    value={donationsPerPage}
                                                    onChange={(e) => setDonationsPerPage(Number(e.target.value))} // ✅ Updates state
                                                    style={{ width: 'auto', marginRight: '10px' }}
                                                >
                                                    <option value="10">10 / page</option>
                                                    <option value="20">20 / page</option>
                                                    <option value="40">40 / page</option>
                                                </Form.Select>
                                            </div>
                                            <label className="pagination-controls-goto-label" htmlFor="goto-page">
                                                Go to
                                            </label>
                                            <Form.Control
                                                type="number"
                                                value={currentPage}
                                                className="pagination-controls-goto-input"
                                                onChange={(e) => {
                                                    const newPage = Number(e.target.value);
                                                    if (newPage >= 1 && newPage <= totalPages) {
                                                        setCurrentPage(newPage); // ✅ Only valid pages
                                                    }
                                                }}
                                                onBlur={() => {
                                                    if (currentPage < 1) setCurrentPage(1);
                                                    if (currentPage > totalPages) setCurrentPage(totalPages);
                                                }}
                                                style={{ textAlign: 'center' }}
                                            />
                                        </Col>
                                    </Row>
                                </Card.Body>
                        </Card>
                    </div>
                </Container>
            </main>

            {/* Donate Modal */}
            <DonateModal
                show={showDonateModal}
                onHide={() => setShowDonateModal(false)}
                currency="€"
                amount={donateAmount}
                setAmount={setDonateAmount}
                loading={donateLoading}
                error={donateError}
                onPay={handleDonatePay}
            />


            {/* Success Modal */}
            <Modal className="with-form" show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        src={icSucess}
                        alt=""
                        className="d-block m-auto mb-4"
                    />
                    <h2 className="text-center mb-3">Thank you for your donation!</h2>
                    <p className="text-center">
                        To receive your donation certificate, please complete the registration process. Step 1: Register your email address. Step 2: Download your certificate and create a password. Step 3 (optional): Access abroadify to download the certificate(s) again including password management.
                    </p>
                </Modal.Body>
                {(!!user || !user) && ( // ✅ always show footer (or just remove the condition)
                    <Modal.Footer className="d-flex justify-content-center">
                        {user && ( // ✅ ALL logged-in users
                            <Button
                                variant="outline-secondary"
                                className="me-3"
                                onClick={() => downloadLatestCertificate()} // ✅ always clickable
                            >
                                Download certificate
                            </Button>
                        )}

                        {!user && ( // ✅ only for guests
                            <Button
                                variant="primary"
                                onClick={sendMagicLink}
                                disabled={magicLoading || magicSent || !successSessionId}
                            >
                                {magicLoading ? 'Sending…' : magicSent ? 'Email sent' : 'Send Registration Email'}
                            </Button>
                        )}

                        {user && isDonatorUser && !hasDonatorPassword && ( // ✅ only donator users without password
                            <Button
                                variant="primary"
                                onClick={() => {
                                setShowSuccessModal(false); // ✅
                                setShowSetPwdModal(true);
                                }}
                            >
                                Set password
                            </Button>
                        )}
                    </Modal.Footer>
                )}
            </Modal>

            {/* Canceled Modal */}
            <Modal show={showCanceledModal} onHide={() => setShowCanceledModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h2 className="text-center mb-3">Donation has been canceled</h2>
                    <p className="text-center">No worries - your donation was not completed and no payment was taken. You can try again anytime and continue supporting Abroadify when you’re ready.</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button variant="primary" onClick={() => setShowCanceledModal(false)}>
                        Go to Donations
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Set Password Modal */}
            <Modal
                show={showSetPwdModal}
                onHide={() => setShowSetPwdModal(false)}
                centered
                className="with-form"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Set your password</Modal.Title>
                </Modal.Header>

                <Form onSubmit={(e) => { e.preventDefault(); submitPassword(); }}>
                    <Modal.Body>
                        <p className="text-center mb-4">
                            Create a password for your donator account.
                        </p>

                        <Form.Group className="mb-3">
                            <Form.Label>New password</Form.Label>

                            <div style={{ position: 'relative' }}>
                                <Form.Control
                                    type={showPwd1 ? 'text' : 'password'}
                                    value={pwd1}
                                    onChange={(e) => setPwd1(e.target.value)}
                                    autoComplete="new-password"
                                    placeholder="Enter password"
                                    style={{ paddingRight: '42px' }} // ✅ space for icon
                                />

                                <img
                                    src={showPwd1 ? icEye : icEyeClosed}
                                    alt=""
                                    width={16}
                                    height={16}
                                    onClick={() => setShowPwd1(v => !v)}
                                    style={{
                                        position: 'absolute',
                                        right: '12px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        opacity: 0.7,
                                    }}
                                />
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Repeat password</Form.Label>

                            <div style={{ position: 'relative' }}>
                                <Form.Control
                                    type={showPwd2 ? 'text' : 'password'}
                                    value={pwd2}
                                    onChange={(e) => setPwd2(e.target.value)}
                                    autoComplete="new-password"
                                    placeholder="Repeat password"
                                    style={{ paddingRight: '42px' }}
                                />

                                <img
                                    src={showPwd2 ? icEye : icEyeClosed}
                                    alt=""
                                    width={16}
                                    height={16}
                                    onClick={() => setShowPwd2(v => !v)}
                                    style={{
                                        position: 'absolute',
                                        right: '12px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        opacity: 0.7,
                                    }}
                                />
                            </div>
                        </Form.Group>

                        <div className="mt-3">
                            <div className="mb-2 font-size-sm">
                                Create password that contains at least:
                            </div>

                            <div className="row g-2 font-size-sm">
                                <div className="col-6">
                                    <div className={pwdChecks.minLen ? 'text-success' : 'text-danger'}>
                                        {pwdChecks.minLen ? '✓' : '✕'} min. 8 characters
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className={pwdChecks.lower ? 'text-success' : 'text-danger'}>
                                        {pwdChecks.lower ? '✓' : '✕'} one lowercase letter
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className={pwdChecks.upper ? 'text-success' : 'text-danger'}>
                                        {pwdChecks.upper ? '✓' : '✕'} one capital letter
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className={pwdChecks.number ? 'text-success' : 'text-danger'}>
                                        {pwdChecks.number ? '✓' : '✕'} one number
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className={pwdChecks.special ? 'text-success' : 'text-danger'}>
                                        {pwdChecks.special ? '✓' : '✕'} one special character
                                    </div>
                                </div>

                                {pwdMatch !== null && (
                                    <div className="col-12">
                                        <div className={pwdMatch ? 'text-success' : 'text-danger'}>
                                            {pwdMatch ? '✓' : '✕'} passwords match
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>



                        {pwdMsg && (
                            <div className="mt-3 font-size-sm text-danger">
                                {pwdMsg}
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer className="d-flex justify-content-center">
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={pwdLoading}
                        >
                            {pwdLoading ? 'Saving…' : 'Save password'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>


            {/* Password Saved Modal */}
            <Modal
                show={showPwdSuccessModal}
                onHide={() => setShowPwdSuccessModal(false)}
                centered
                className="with-form"
            >
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Image
                        src={icSucess}
                        alt=""
                        className="d-block m-auto mb-4"
                    />
                    <h2 className="text-center mb-3">Password saved!</h2>
                    <p className="text-center">
                        You can now log in using your email and password.
                    </p>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-center">
                    <Button variant="primary" onClick={() => setShowPwdSuccessModal(false)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
    
        </>
        
    );
};

export default DonationsMy;
